/**
 * DOM utility type definitions
 */


/**
 * Offset result from element position calculations
 */
export interface ElementOffset {
    top: number;
    right: number;
    bottom: number;
    left: number;
}

/**
 * Dimensions for hidden elements
 */
export interface HiddenDimensions {
    width: number;
    height: number;
}

/**
 * Shadow dimensions from box-shadow CSS
 */
export interface ShadowDimensions {
    left: number;
    right: number;
    bottom: number;
}

/**
 * Parsed effects object
 */
export interface ParsedEffects {
    [key: string]: string;
}

/**
 * Direction mapping for animations
 */
export interface DirectionInfo {
    reverse: string;
}

/**
 * Animation directions
 */
export const DIRECTIONS: Record<string, DirectionInfo> = {
    left: { reverse: "right" },
    right: { reverse: "left" },
    down: { reverse: "up" },
    up: { reverse: "down" },
    top: { reverse: "bottom" },
    bottom: { reverse: "top" },
    "in": { reverse: "out" },
    out: { reverse: "in" }
};


/**
 * Options for the progress/loading mask
 */
export interface ProgressOptions {
    width?: string | number;
    height?: string | number;
    top?: number;
    opacity?: boolean;
}

/**
 * Result of horizontal scroll operation
 */
export interface ScrollResult {
    atStart: boolean;
    atEnd: boolean;
}

/**
 * Result of vertical scroll operation
 */
export interface VerticalScrollResult {
    atTop: boolean;
    atBottom: boolean;
}

/**
 * Options for vertical scroll by delta
 */
export interface VerticalScrollOptions {
    duration?: string | number;
    easing?: string;
}

/**
 * Options for scrollToElement
 */
export interface ScrollToElementOptions {
    duration?: number;
    easing?: string;
    position?: 'top' | 'center' | 'bottom';
    offset?: number;
    onComplete?: () => void;
}

/**
 * Options for drag-to-scroll handler
 */
export interface DragToScrollOptions {
    namespace: string;
    captureElement?: JQuery;
    delegateSelector?: string;
}

/**
 * Drag-to-scroll handler returned by createDragToScrollHandler
 */
export interface DragToScrollHandler {
    attach(): void;
    destroy(): void;
}

/**
 * Options for creating a ResizeObserverService instance
 */
export interface ResizeObserverServiceOptions {
    element: HTMLElement | JQuery;
    onResize: () => void;
    debounceTime?: number;
    observeOptions?: ResizeObserverOptions;
}
